import axios from "axios";
import { GURL } from "./global";
//const SERVER_URL = "http://localhost:5235/api";

export const GetFilesEntityId = (id: any) => {
  const url = `${GURL}/Medium/v1/MediumFile/GetFilesEntityId/${id}?id=${id}`;
  //console.log(url);
  return axios.get(url);
};
export const GetFileByEntityId = (id: any) => {
  const url = `${GURL}/Medium/v1/MediumFile/GetFileByEntityId/${id}?id=${id}`;
  //console.log(url);
  return axios.get(url);
};

export const GetFileById = (id: any) => {
  const url = `${GURL}/Medium/v1/MediumFile/GetFile/${id}?id=${id}`;
  //console.log(url);
  return axios.get(url, {
    responseType: "blob",
    headers: {
      Accept: "application/octet-stream",
    },
  });
};
export const UploadImage = (body: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Medium/v1/MediumFile/Upload/Cover`, body);
};

export const DeleteFileById = (body: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Medium/v1/MediumFile/DeleteFile`, body);
};

export const UploadFile = (noticeId: any, body: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(
    `${GURL}/Medium/v1/MediumFile/Upload?noticeId=${noticeId}`,
    body
  );
};

export const GetCover = (body: any) => {
  return axios.get(
    `${GURL}/Medium/v1/MediumFile/GetCover?entityId=${body.entityId}&entityNameId=${body.entityNameId}`
  );
};
